import React, { useState, useRef, useContext, useEffect } from "react";
import style from "./ReactWizard.module.css";
import { UserContext } from "../../stores/Context/Context";
import Sutabwarpped from "../wizard/Subtabwarpped";
import { useDispatch, useSelector } from "react-redux";
import { language } from "../../stores/slices/languageSlice";
export default function ReactWizard(props) {
  const selectedLanguage = useSelector(language).Registrations.reactWizard;
  let contText = useContext(UserContext);
  const [warppedValidations, setWarppedValidation] = useState(false);
  const [isSubtab, setIsSubtab] = useState(false);
  const [count, setCount] = useState(1);
  const nextButtonClick = (e) => {
    let isValid = contText?.formValidation?.isValidate();

    let tabLength = props.Tabs.length;
    let nextstep = count + 1;
    nextstep =
      nextstep === 0 ? 1 : tabLength <= nextstep ? tabLength : nextstep;
    if (isSubtab) {
      if (warppedValidations) {
        setCount(nextstep);
      }
      setIsSubtab(false);
    } else {
      if (isValid) {
        setCount(nextstep);
      }
    }
  };

  const cancelButtonClick = (e) => {
    // e.preventDefault()

    props.cancelFunction();
  };
  const previousButtonClick = (e) => {
    let tabLength = props.Tabs.length;
    let previosStep = count - 1;
    setCount(previosStep);
  };
  useEffect(() => {
    setCount(props.initialTab != undefined ? props.initialTab : 1);
  }, []);

  return (
    <>
      <div className={`intro-y box py-5 mt-10 mb-5 ${style.basic_page}`}>
        <div className="d-flex justify-content-center flex-column">
          <div className={`pt-2 ${style.Welcome_text}`}>{props.title}</div>
          <div className={`pt-2 ${style.Welcome_text2}`}>{props.subTitle}</div>
        </div>
        <div className="wizard d-flex flex-column flex-lg-row justify-content-center px-1  mt-5">
          {typeof props.Tabs != "undefined" &&
            props.Tabs.length > 0 &&
            props.Tabs.map((value, index) => {
              return (
                <div
                  className={`intro-x text-lg-center p-2 d-flex align-items-center d-lg-block flex-1 z-10 ${
                    style.basic_tap
                  } ${
                    count == index + 1 ? style.activetabs : style.inactivetabs
                  }`}
                  key={index}
                >
                  {value.label}
                </div>
              );
            })}
        </div>

        <div className="px-5  text-center">
          {props.Tabs.map((x, index) => {
            return (
              <>
                {" "}
                {count == index + 1 ? (
                  <div key={index} className={style.wizard_tab}>
                    {x.isSubTab != true ? (
                      x.component
                    ) : (
                      <>
                        <Sutabwarpped
                          setIsSubtap={setIsSubtab}
                          setWarppedValidation={setWarppedValidation}
                          subTab={x.subTab}
                        />
                      </>
                    )}
                  </div>
                ) : null}
              </>
            );
          })}

          <div
            className={`intro-y g-col-12 align-items-center mt-10 ${style.wizard_button}`}
          >
            <div>
              <>
                {props.finishButtonText == "REGISTER" ? (
                  <button
                    onClick={cancelButtonClick}
                    className={`btn ${style.cancel_button}`}
                  >
                    {selectedLanguage?.cancel}
                  </button>
                ) : count == 1 ? (
                  <></>
                ) : (
                  <button
                    onClick={previousButtonClick}
                    className={`btn ${style.cancel_button}`}
                  >
                    {selectedLanguage?.previous}
                  </button>
                )}
              </>
            </div>
            <div>
              {props.Tabs.length == count ? (
                <>
                  {props.finishButtonText == "REGISTER" ? (
                    <button
                      onClick={nextButtonClick}
                      className={`btn ${props.registerButtonEnbleflag ? '' :  `${style.isButtonIsdisabled}`} ${style.next_button}`}
                    >
                      {props.finishButtonText}
                    </button>
                  ) : (
                    <button
                      onClick={nextButtonClick}
                      className={`btn ${style.next_button}`}
                    >
                      {props.finishButtonText}
                    </button>
                  )}
                </>
              ) : (
                <button
                  onClick={nextButtonClick}
                  className={`btn ${style.next_button}`}
                >
                  {selectedLanguage?.next}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
